import {gql} from "apollo-boost";

export const DegreesQuery = gql`
    query Degrees($institutionId: Int!, $scheduleId :Int!){
        degrees(institutionId:$institutionId, scheduleId:$scheduleId){
            levelId
            programId
            degreeId
            description
        }
    }

`;


export const DegreesFunColQuery = gql`
    query DegreesFunCol {
        degreesFunCol{
            levelId
            programId
            degreeId
            description
        }
    }

`;


export const DegreesBacQuery = gql`
    query DegreesBac {
        degreesBac{
            levelId
            programId
            degreeId
            description
        }
    }

`;


